import OrderAction from './orderAction';
import Order from '../models/orderModel';
import PaidPostAction from '../post-action/paidPostAction';

export default class PaidAction extends OrderAction {
    static NAME = 'paid';
    static POST_ACTION_COMPONENT = PaidPostAction;
    //@Todo to uncomment when action async will be functionnal
    static ASYNCHRONOUS_LIMIT_MIN = 25;

    //only reserved
    static condition(order) {
        return order.status === 'reservation' && order.attendee_count > order.attendees_deleted_count;
    }

    static is_available({ event, feature_flags }) {
        return !(feature_flags.includes('EO_FREE') && !['over', 'closed'].includes(event.status));
    }

    run() {
        return Promise.resolve(true);
    }

    get is_direct() {
        return true;
    }

    // simple and global
    get needs_confirm() {
        return false;
    }

    get needs_selection() {
        return false;
    }

    onActionDone() {
        if (!this.async) {
            this.sync();
        }
        this.onClose();
    }

    get post_action() {
        return true;
    }

    runPostAction({ orders, send_receipt }) {
        return Order.perform_action(this.constructor.NAME, orders, { organization: this.organization, event: this.event, send_receipt }, this.isAsync(orders));
    }
}
